import { ListInvitation } from "models/list-invitation";
import { Locale, LocaleString } from "models/locale";
import { doGet } from "services/request";

export const userDoGetListInvitation = async (invitationUuid: string) => {
  const invitation = await doGet<ListInvitation>(
    `/user/invitation/${invitationUuid}`,
  );
  return invitation;
};

export const userdoGetListInvitationDetails = async (
  invitationUuid: string,
) => {
  const details = await doGet<{ name: LocaleString; locale: Locale }>(
    `/user/invitation/${invitationUuid}/details`,
  );
  return details;
};
